const cardInfo = [
   {
    title: "SpliffDAO Proof of Sesh",
    description:
      "BluntDAO finally accepts Spliffs. Proof of Sesh with an OG Validator to get the NFT. Get the OG Validator NFT on Solana FIrst",
    img: "/img/SpliffDAOWatermark.png",
    url: "https://solscan.io/token/EKoubfYoTcfdj6uML7dnUPFFwMHkRTWZM5cMpNDrzxku",
  },
    {
    title: "BluntDAO Proof of Sesh by Cupcake",
    description:
      "Brought to you by B+J. Claim the BluntDAO Proof of Sesh on Solana with just a phone number",
    img: "/img/banner.gif",
    url: "https://solscan.io/token/F8rfnjdQTxLTKKMQ9M6LWbP4aiiqUkQSs6jxpBSRcVPz",
  },
  {
    title: "BluntDAO Tweet NFTs",
    description:
      "The following nfts were minted on Polygon to forever cement BluntDAO's rise to fam on twitter.",
    img: "/img/BluntDAO-Tweet-NFTs.png",
    url: "https://opensea.io/collection/blunttwitter",
  },
  {
    title: "Apply to Be in BluntDAO Art Launchpad",
    description:
      "Have your blunt related art showcased on the premium BluntDAO gallery link.",
    img: "/img/BluntDAO-Art-Launchpad.png",
    url: "https://forms.gle/XLfEbuYvh7wQZbQt5",
  },
  {
    title: "OG 420 Validator [NEAR]",
    description:
      "This NFT means you are an OG 420 Validator for the BluntDAO on the NEAR Protocol. You can now onboard new Web3 users via Proof of Sesh.",
    img: "/img/BLUNTDAO_NEAR_NFT2.png",
    url: "https://paras.id/token/bluntdao.snft.near::1",
  },
  {
    title: "OG 420 Blunt Validator [SOLANA]",
    description:
      "Original access token for first 420, before introduction of semi-fungible $BLUNT token. Notable for being inception of BluntDAO at the Shrimp Society House at the Miami Hack Week.",
    img: "/img/BluntDAO420solana.png",
    url: "https://bluntdao.holaplex.market/creators/FmBMdM2DFrhhiBtvCD7Vx35JWbQnAxdYqVjWUd1sMYow",
  },
  {
    title: "LA Solana Hacker House Blunt",
    description:
      "Created during the Los Angeles Solana Hacker House 2022, as an animated hand drawn then scanned Blunt looking over the Hollywood Hills. ",
    img: "/img/BluntDAOLA.gif",
    url: "https://bluntdao.holaplex.market/creators/HjNnsDCEbHiYhT3ssg55k8VGvm1at329EZDYxRfMCysE",
  },
  {
    title: "Valentine's Blunt",
    description:
      "This Blunt was made on Valentine's Day 2022 during #EthDenver with 3 variations of 42 Blunts for Blunt enthusiasts to give to loved ones.",
    img: "/img/valentine.png",
    url: "https://bluntdao.holaplex.market/creators/6e4DZ631PcZSWDsqki3HxcKjGcvcCKgG8KU1BZPQ6BGi",
  },
  {
    title: "Shrimp Society Blunt",
    description:
      "This was drawn during the Shrimp Society Solana Hacker House. Originally intended to be updated at O 420 Blunt Validator, but will be given as a separate airdrop to avoid confusion. But too high didn't get to it",
    img: "/img/miami.png",
  },

  {
    title: "VR Sesh Room",
    description:
      "This yet to be minted Metaverse Sesh Room is made for the Blunt DAO to Proof of Sesh in digital reality.",
    img: "/img/SeshRoom.png",
  },
  {
    title: "Eth Denver 2022 Blunt",
    description:
      "We got so high we didn't even do this one. We also had another Ethereum Blunt version. Made by @dyrmkr",
    img: "/img/ethblunt.gif",
  },
  {
    title: "BluntDAO Solana Pass",
    description:
      "This limited edition 1/200 NFT gets you access to in-real-life experiences to networking & music events during Solana events & the first NY BluntDAO popup party!",
    img: "/img/vinyl.gif",
    url: "https://www.holaplex.com/nfts/Eomc7PDsERkbYJZS8bNGUFcYPcSsgYkT7nNdZ4JTCv4F",
  },
];

export default cardInfo;
